export const languageLabels = {
  en: 'Inglés',
  es: 'Español',
  fr: 'Francés',
  pt: 'Portugués',
  it: 'Italiano',
  de: 'Alemán',
  nl: 'Neerlandés',
  ko: 'Coreano',
}

export const legacyFieldKeyPrefixes = {
  portal_preferences: 'preferences',
  portal_theme: 'theme',
  portal_communications: 'communications',
  portal_email_theme: 'email_theme',
  portal_settings: 'settings',
}

export const copyBaseKeyLabels = {
  'start_screen.order_number': 'Número de pedido',
  'start_screen.email_postcode': 'Email o código postal',
  'exchanges.variants': 'Otra talla/color',
  'exchanges.other_products': 'Un producto diferente',
  'exchanges.out_of_stock': 'Producto no disponible o agotado',
  'error.item_disabled': 'Producto bloqueado',
  'error.item_too_old': 'Producto fuera de plazo',
  'error.item_not_enough_quantity': 'Producto devuelto anteriormente',
  'error.item_unfulfilled': 'Producto sin enviar',
  'error.item_no_variants': 'Producto sin variantes',
  'error.order_not_found': 'Pedido no encontrado',
  'error.order_cancelled': 'Pedido cancelado',
  'error.disabled_by_rule': 'Pedido bloqueado por regla',
  'error.from_previous_exchange': 'Pedido de cambio previo',
  'error.order_no_amount': 'Pedido con importe nulo',
  'error.order_with_giftcard': 'Tarjeta regalo',
  'error.has_external_returns': 'Devoluciones externas',
  'error.order_disabled_channel': 'Canal de venta deshabilitado',
  'error.order_region_not_allowed': 'Región no permitida',
  'error.order_pending_payment': 'Pago pendiente',
  'error.order_with_chargeback': 'Pedido con contracargo',
  'error.exchange_not_allowed': 'Cambio no permitido',
  'delivery_method.customerpickup': 'Recogida a domicilio',
  'delivery_method.pickuppoint': 'Punto de entrega',
  'delivery_method.returntostore': 'Entrega en tienda',
  'delivery_method.customerdelivers': 'Envíalo por tu cuenta',
  'summary.instant_refund.bank_transfer': 'Reembolso instantáneo: Transferencia bancaria instantánea',
  'summary.instant_refund.original_payment_method': 'Reembolso instantáneo: Método de pago original',
  'summary.instant_refund.gift_card': 'Reembolso instantáneo: Tarjeta regalo',
  'summary.instant_refund.store_credit': 'Reembolso instantáneo: Crédito en tienda',
  'summary.refund.original_payment_method': 'Reembolso: Método de pago original',
  'summary.refund.gift_card': 'Reembolso: Tarjeta regalo',
  'summary.refund.store_credit': 'Reembolso: Crédito en tienda',
  'summary.instant_exchange': 'Cambio instantáneo',
  'summary.exchange': 'Cambio',
}

export const widgetTextBaseLabels = {
  'widget.text': 'Usar texto personalizado',
  'recommendation_widget.too_big_text': 'Usar texto personalizado para productos que tallen grande',
  'recommendation_widget.too_small_text': 'Usar texto personalizado para productos que tallen pequeño',
  'top_banner_widget.text': 'Texto personalizado del banner',
  'bracketing_widget.title_text': 'Título del banner',
  'bracketing_widget.content_text': 'Contenido del banner',
}

const languages = Object.keys(languageLabels)

const withPrefix = (prefix, fields) => fields.map(field => `${prefix}.${field}`)

const withLegacyPrefix = (prefix, fields) => {
  return [...withPrefix(prefix, fields), ...withPrefix(legacyFieldKeyPrefixes[prefix], fields)]
}

const withLanguages = keys => keys.flatMap(key => languages.map(language => `${key}_${language}`))

const brandingColorFields = [
  'primary_brand_color',
  'split_button_background_color',
  'split_button_border_color',
  'split_button_text_color',
  'split_button_icon_color',
  'split_button_background_hover_color',
  'split_button_border_hover_color',
  'split_button_text_hover_color',
  'split_button_icon_hover_color',
  'split_button_background_selected_color',
  'split_button_border_selected_color',
  'split_button_text_selected_color',
  'split_button_icon_selected_color',
  'variant_background_color',
  'variant_border_color',
  'variant_text_color',
  'variant_background_hover_color',
  'variant_border_hover_color',
  'variant_text_hover_color',
  'variant_background_disabled_color',
  'variant_border_disabled_color',
  'variant_text_disabled_color',
  'variant_background_selected_color',
  'variant_border_selected_color',
  'variant_text_selected_color',
  'button_background_color',
  'button_border_color',
  'button_text_color',
  'button_background_hover_color',
  'button_border_hover_color',
  'button_text_hover_color',
  'button_background_disabled_color',
  'button_border_disabled_color',
  'button_text_disabled_color',
  'button_simple_text_color',
  'button_simple_text_hover_color',
  'button_simple_text_disabled_color',
  'link_color',
  'link_hover_color',
]

const brandingImageFields = [
  'logo',
  'returns_favicon',
  'returns_background',
  'returns_background_mobile',
  'returns_cover',
  'emails_footer_image',
  'emails_footer_url',
  'tracking_footer_image',
  'tracking_footer_url',
]

const emailThemeFields = [
  'background_color',
  'content_background_color',
  'header_background_color',
  'footer_background_color',
  'footer_image',
  'link_color',
  'h1_font_family',
  'h1_font_size',
  'h1_is_bold',
  'h1_is_italic',
  'h1_color',
  'h2_font_family',
  'h2_font_size',
  'h2_is_bold',
  'h2_is_italic',
  'h2_color',
  'h3_font_family',
  'h3_font_size',
  'h3_is_bold',
  'h3_is_italic',
  'h3_color',
  'body_font_family',
  'body_font_size',
  'body_is_bold',
  'body_is_italic',
  'body_color',
]

export const settingsFieldKeys = {
  store: [
    'store.contact_email',
    'store.default_language',
    'store.supported_languages',
    'store.contact_url',
    ...withLegacyPrefix('portal_preferences', ['returns_policy_url', 'help_center_url']),
  ],
  'policy-config': [
    ...withLegacyPrefix('portal_preferences', [
      'allows_refunds',
      'max_duration_for_refund',
      'refund_reference_date',
      'shipping_included',
      'allows_exchanges',
      'max_duration_for_exchange',
      'exchange_reference_date',
      'allowed_exchange_methods',
      'allow_even_exchanges_catalog_price',
      'exchange_orders_automatic_creation',
      'issue_exchange_at_status',
      'exchange_orders_send_provider_notification',
      'exchange_payment_expiration_delta',
      'allows_instant_exchanges',
      'instant_exchange_orders_automatic_creation',
      'instant_exchange_orders_send_provider_notification',
      'instant_exchange_payment_expiration_delta',
      'exchange_error_resolution',
      'allows_gift_returns',
      'skip_identifier_validation',
      'broken_discount_handling',
      'buyxgety_broken_discount_handling',
      'broken_discount_bonus_enabled',
      'broken_discount_custom_message_enabled',
      'broken_discount_custom_message',
      'buyxgety_return_policy',
      'bundle_return_policy',
      'bundle_allowed_requests',
      'manage_restock',
      'return_cancel_deadline_days',
    ]),
    ...withLegacyPrefix('portal_settings', ['return_preferences']),
  ],
  'policy-exceptions': ['exception'],
  'policy-policy-rules': ['policy_rule'],
  refunds: [
    'refund_method',
    ...withLegacyPrefix('portal_preferences', ['issue_refund_at_status']),
    ...withLegacyPrefix('portal_settings', ['refund_methods']),
  ],
  'logistics-general': [
    'shipments.shipping_skip_packing',
    'shipments.shipping_fulfillment',
    ...withPrefix(legacyFieldKeyPrefixes.portal_preferences, ['shipping_skip_packing', 'shipping_fulfillment']),
    ...withLegacyPrefix('portal_preferences', ['label_format']),
  ],
  'logistics-shipping-methods': ['shipping_method'],
  'logistics-delivery-methods': ['delivery_method'],
  'logistics-locations': ['location'],
  'logistics-packaging': ['packaging'],
  'reasons-list': ['return_reason'],
  'reasons-settings': withLegacyPrefix('portal_preferences', [
    'return_reasons_sorting',
    'return_subreasons_sorting',
    'show_rejected',
  ]),
  inventory: withPrefix('shipments', [
    'default_inventory_item_hs_code',
    'default_inventory_item_hts_code',
    'default_inventory_item_mid_code',
    'default_inventory_item_ns_pid',
    'default_inventory_item_country_from',
    'default_inventory_item_weight',
    'default_inventory_item_weight_unit',
  ]),
  branding: [
    ...withLegacyPrefix('portal_theme', [...brandingColorFields, ...brandingImageFields]),
    ...withLegacyPrefix('portal_settings', ['theme']),
  ],
  'returnsPortal-configuration': withLegacyPrefix('portal_preferences', [
    'contact_method',
    'product_variant_exchange_taxonomy_type',
    'product_variant_exchange_taxonomy_display',
    'product_variant_exchange_taxonomy_ids',
    'product_variant_exchange_recommendation_type',
    'product_variant_exchange_recommendation_value',
    'allows_order_recovery',
    'skip_single_refund_method_step',
  ]),
  'returnsPortal-copies': withLanguages(Object.keys(copyBaseKeyLabels)),
  'communications-general': [
    ...withLegacyPrefix('portal_communications', [
      'reply_to_type',
      'reply_to_email',
      'notification_types',
      'language',
      'billing_email',
      'billing_cc_emails',
    ]),
    ...withLegacyPrefix('portal_settings', ['communication_preferences']),
  ],
  'communications-email-templates': ['email_template', ...withLegacyPrefix('portal_settings', ['email_templates'])],
  'communications-themes': [
    ...withLegacyPrefix('portal_email_theme', emailThemeFields),
    ...withLegacyPrefix('portal_settings', ['email_theme']),
  ],
  integrations: ['integration'],
  users: ['user', 'group'],
  'extras-reveni-widget': withPrefix('widget', [
    'background_color',
    'text_color',
    'link_color',
    'show_custom_text',
    ...withLanguages(['text']),
  ]),
  'extras-shipping-widget': withPrefix('shipping_widget', [
    'background_color',
    'text_color',
    'actions_color',
    'free_shipping_background_color',
    'free_shipping_text_color',
    'sorting',
  ]),
  'extras-sizing-widget': withPrefix('recommendation_widget', [
    'background_color',
    'text_color',
    ...withLanguages(['too_big_text', 'too_small_text']),
    'product_taxonomy_display',
    'product_taxonomy_ids',
  ]),
  'extras-top-banner-widget': withPrefix('top_banner_widget', [
    'background_color',
    'text_color',
    'link_color',
    ...withLanguages(['text']),
  ]),
  'extras-bracketing-widget': withPrefix('bracketing_widget', [
    'background_color',
    'text_color',
    'link_color',
    ...withLanguages(['title_text', 'content_text']),
    'size_guide_url',
  ]),
  'extras-try-on-widget': withPrefix('tryon_widget', [
    'background_color',
    'text_color',
    'button_color',
    'button_hover_color',
    'product_taxonomy_type',
    'product_taxonomy_display',
    'product_taxonomy_ids',
  ]),
  'returnProtection-appearance': [
    ...withPrefix('return_protection', [
      'widget_background_color',
      'widget_text_color',
      'widget_link_color',
      'popup_header_image',
      'popup_overlay_color',
      'popup_header_text_color',
      'popup_body_text_color',
      'decline_action_style',
    ]),
    ...withPrefix('return_protection_product', ['product_image', 'product_title']),
  ],
}

export const fieldKeyLabels = {
  'store.contact_email': 'Email de contacto para clientes',
  'store.default_language': 'Idioma por defecto',
  'store.supported_languages': 'Idiomas soportados',
  'store.contact_url': 'URL de contacto para clientes',
  'portal_preferences.returns_policy_url': 'URL Política de devoluciones',
  'portal_preferences.help_center_url': 'URL Centro de ayuda para clientes',
  'portal_preferences.allows_refunds': 'Permitir devoluciones',
  'portal_preferences.max_duration_for_refund': 'Plazo devoluciones (días naturales)',
  'portal_preferences.refund_reference_date': 'A contar desde',
  'portal_preferences.shipping_included':
    'Reembolsar gastos de envío de la compra original si se devuelven todos los productos',
  'portal_preferences.allows_exchanges': 'Permitir cambios',
  'portal_preferences.max_duration_for_exchange': 'Plazo para cambios (días naturales)',
  'portal_preferences.exchange_reference_date': 'A contar desde',
  'portal_preferences.allowed_exchange_methods': 'Tipos de cambios permitidos',
  'portal_preferences.allow_even_exchanges_catalog_price': 'Cambio de variante',
  'portal_preferences.exchange_orders_automatic_creation': 'Nuevos productos solicitados',
  'portal_preferences.issue_exchange_at_status': 'Crear nuevo pedido',
  'portal_preferences.exchange_orders_send_provider_notification':
    'Permitir que Shopify envíe email de confirmación del nuevo pedido',
  'portal_preferences.exchange_payment_expiration_delta': 'Ventana de pago para pedidos con pago pendiente (en horas)',
  'portal_preferences.allows_instant_exchanges': 'Permitir cambios',
  'portal_preferences.instant_exchange_orders_automatic_creation': 'Nuevos productos solicitados',
  'portal_preferences.instant_exchange_orders_send_provider_notification':
    'Permitir que Shopify envíe email de confirmación del nuevo pedido',
  'portal_preferences.instant_exchange_payment_expiration_delta':
    'Ventana de pago para pedidos con pago pendiente (en horas)',
  'portal_preferences.exchange_error_resolution': 'Resolución error pedidos de cambio',
  'portal_preferences.allows_gift_returns': 'Habilitar devoluciones de regalos',
  'portal_preferences.skip_identifier_validation': 'Datos del pedido necesarios para iniciar el proceso.',
  'portal_preferences.broken_discount_handling': 'Gestión de descuento roto',
  'portal_preferences.buyxgety_broken_discount_handling': 'Gestión de descuento roto',
  'portal_preferences.broken_discount_bonus_enabled':
    'Reembolsar la fee de descuento roto a medida que se devuelvan los productos afectados',
  'portal_preferences.broken_discount_custom_message_enabled': 'Mostrar mensaje personalizado',
  'portal_preferences.broken_discount_custom_message': 'Mensaje personalizado',
  'portal_preferences.buyxgety_return_policy': 'Devolución de descuentos Compra X Obtén Y',
  'portal_preferences.bundle_return_policy': 'Devolución de paquetes de productos',
  'portal_preferences.bundle_allowed_requests': 'Solicitudes permitidas',
  'portal_preferences.manage_restock': 'Reponer productos por defecto al aceptar su devolución',
  'portal_preferences.return_cancel_deadline_days': 'Cancelación automática',
  'portal_preferences.issue_refund_at_status': 'Emisión del reembolso',
  'portal_preferences.shipping_skip_packing': 'Pantalla de empaquetado',
  'portal_preferences.shipping_fulfillment': 'Estado de envío',
  'portal_preferences.label_format': 'Formato de etiqueta',
  'portal_preferences.show_rejected': 'Visibilidad de notas e imágenes productos rechazados',
  'portal_preferences.return_reasons_sorting': 'Ordenación motivos de devolución',
  'portal_preferences.return_subreasons_sorting': 'Ordenación submotivos de devolución',
  'portal_preferences.contact_method': 'Método de contacto para clientes',
  'portal_preferences.product_variant_exchange_taxonomy_type': 'Agrupación de productos para navegación',
  'portal_preferences.product_variant_exchange_taxonomy_display': 'Mostrar',
  'portal_preferences.product_variant_exchange_taxonomy_ids': 'Categorías de producto seleccionadas',
  'portal_preferences.product_variant_exchange_recommendation_type': 'Recomendar productos',
  'portal_preferences.product_variant_exchange_recommendation_value': 'Recomendar productos',
  'portal_preferences.allows_order_recovery': 'Permitir que los clientes busquen su pedido por email',
  'portal_preferences.skip_single_refund_method_step': 'Saltar el paso si solo hay un método de reembolso disponible',
  'portal_settings.return_preferences': 'Tipo de configuración',
  'portal_settings.refund_methods': 'Tipo de configuración',
  'portal_settings.theme': 'Tipo de configuración',
  'portal_settings.communication_preferences': 'Tipo de configuración',
  'portal_settings.email_templates': 'Tipo de configuración',
  'portal_settings.email_theme': 'Tipo de configuración',
  'shipments.shipping_skip_packing': 'Pantalla de empaquetado',
  'shipments.shipping_fulfillment': 'Estado de envío',
  'shipments.default_inventory_item_hs_code': 'Código HSCode por defecto para productos',
  'shipments.default_inventory_item_hts_code': 'Código HTS por defecto para productos',
  'shipments.default_inventory_item_mid_code': 'Código MID por defecto para productos',
  'shipments.default_inventory_item_ns_pid': 'Código NS-PID por defecto para productos',
  'shipments.default_inventory_item_country_from': 'País de origen por defecto para productos',
  'shipments.default_inventory_item_weight': 'Peso por defecto para productos',
  'shipments.default_inventory_item_weight_unit': 'Unidad de peso por defecto para productos',
  'portal_theme.primary_brand_color': 'Color de marca primario',
  'portal_theme.split_button_background_color': 'Selectores de método / solicitud: Fondo (Normal)',
  'portal_theme.split_button_border_color': 'Selectores de método / solicitud: Borde (Normal)',
  'portal_theme.split_button_text_color': 'Selectores de método / solicitud: Texto (Normal)',
  'portal_theme.split_button_icon_color': 'Selectores de método / solicitud: Icono (Normal)',
  'portal_theme.split_button_background_hover_color': 'Selectores de método / solicitud: Fondo (Hover)',
  'portal_theme.split_button_border_hover_color': 'Selectores de método / solicitud: Borde (Hover)',
  'portal_theme.split_button_text_hover_color': 'Selectores de método / solicitud: Texto (Hover)',
  'portal_theme.split_button_icon_hover_color': 'Selectores de método / solicitud: Icono (Hover)',
  'portal_theme.split_button_background_selected_color': 'Selectores de método / solicitud: Fondo (Seleccionado)',
  'portal_theme.split_button_border_selected_color': 'Selectores de método / solicitud: Borde (Seleccionado)',
  'portal_theme.split_button_text_selected_color': 'Selectores de método / solicitud: Texto (Seleccionado)',
  'portal_theme.split_button_icon_selected_color': 'Selectores de método / solicitud: Icono (Seleccionado)',
  'portal_theme.variant_background_color': 'Selector de variante: Fondo (Normal)',
  'portal_theme.variant_border_color': 'Selector de variante: Borde (Normal)',
  'portal_theme.variant_text_color': 'Selector de variante: Texto (Normal)',
  'portal_theme.variant_background_hover_color': 'Selector de variante: Fondo (Hover)',
  'portal_theme.variant_border_hover_color': 'Selector de variante: Borde (Hover)',
  'portal_theme.variant_text_hover_color': 'Selector de variante: Texto (Hover)',
  'portal_theme.variant_background_disabled_color': 'Selector de variante: Fondo (Deshabilitado)',
  'portal_theme.variant_border_disabled_color': 'Selector de variante: Borde (Deshabilitado)',
  'portal_theme.variant_text_disabled_color': 'Selector de variante: Texto (Deshabilitado)',
  'portal_theme.variant_background_selected_color': 'Selector de variante: Fondo (Seleccionado)',
  'portal_theme.variant_border_selected_color': 'Selector de variante: Borde (Seleccionado)',
  'portal_theme.variant_text_selected_color': 'Selector de variante: Texto (Seleccionado)',
  'portal_theme.button_background_color': 'Botones primarios: Fondo (Normal)',
  'portal_theme.button_border_color': 'Botones primarios: Borde (Normal)',
  'portal_theme.button_text_color': 'Botones primarios: Texto (Normal)',
  'portal_theme.button_background_hover_color': 'Botones primarios: Fondo (Hover)',
  'portal_theme.button_border_hover_color': 'Botones primarios: Borde (Hover)',
  'portal_theme.button_text_hover_color': 'Botones primarios: Texto (Hover)',
  'portal_theme.button_background_disabled_color': 'Botones primarios: Fondo (Deshabilitado)',
  'portal_theme.button_border_disabled_color': 'Botones primarios: Borde (Deshabilitado)',
  'portal_theme.button_text_disabled_color': 'Botones primarios: Texto (Deshabilitado)',
  'portal_theme.button_simple_text_color': 'Botones simples: Texto (Normal)',
  'portal_theme.button_simple_text_hover_color': 'Botones simples: Texto (Hover)',
  'portal_theme.button_simple_text_disabled_color': 'Botones simples: Texto (Deshabilitado)',
  'portal_theme.link_color': 'Enlaces: Texto (Normal)',
  'portal_theme.link_hover_color': 'Enlaces: Texto (Hover)',
  'portal_theme.logo': 'Logo tienda',
  'portal_theme.returns_favicon': 'Favicon',
  'portal_theme.returns_background': 'Fondo (Desktop)',
  'portal_theme.returns_background_mobile': 'Fondo (Mobile)',
  'portal_theme.returns_cover': 'Imagen portada',
  'portal_theme.emails_footer_image': 'Footer: imagen',
  'portal_theme.emails_footer_url': 'Link de la imagen del footer',
  'portal_theme.tracking_footer_image': 'Imagen del banner',
  'portal_theme.tracking_footer_url': 'Link de la imagen del banner',
  'portal_communications.reply_to_type': 'Usar dirección de Reply-to',
  'portal_communications.reply_to_email': 'Email de respuesta para clientes',
  'portal_communications.notification_types': 'Comunicaciones transaccionales',
  'portal_communications.language': 'Idioma comunicaciones',
  'portal_communications.billing_email': 'Email facturación',
  'portal_communications.billing_cc_emails': 'Destinatarios en copia (Cc)',
  'portal_email_theme.background_color': 'Color de fondo',
  'portal_email_theme.content_background_color': 'Color de fondo del contenido',
  'portal_email_theme.header_background_color': 'Color de fondo del header',
  'portal_email_theme.footer_background_color': 'Color de fondo del footer',
  'portal_email_theme.footer_image': 'Footer: imagen',
  'portal_email_theme.link_color': 'Color de enlaces',
  'portal_email_theme.h1_font_family': 'Encabezado 1: fuente',
  'portal_email_theme.h1_font_size': 'Encabezado 1: tamaño',
  'portal_email_theme.h1_is_bold': 'Encabezado 1: negrita',
  'portal_email_theme.h1_is_italic': 'Encabezado 1: cursiva',
  'portal_email_theme.h1_color': 'Encabezado 1: color',
  'portal_email_theme.h2_font_family': 'Encabezado 2: fuente',
  'portal_email_theme.h2_font_size': 'Encabezado 2: tamaño',
  'portal_email_theme.h2_is_bold': 'Encabezado 2: negrita',
  'portal_email_theme.h2_is_italic': 'Encabezado 2: cursiva',
  'portal_email_theme.h2_color': 'Encabezado 2: color',
  'portal_email_theme.h3_font_family': 'Encabezado 3: fuente',
  'portal_email_theme.h3_font_size': 'Encabezado 3: tamaño',
  'portal_email_theme.h3_is_bold': 'Encabezado 3: negrita',
  'portal_email_theme.h3_is_italic': 'Encabezado 3: cursiva',
  'portal_email_theme.h3_color': 'Encabezado 3: color',
  'portal_email_theme.body_font_family': 'Cuerpo: fuente',
  'portal_email_theme.body_font_size': 'Cuerpo: tamaño',
  'portal_email_theme.body_is_bold': 'Cuerpo: negrita',
  'portal_email_theme.body_is_italic': 'Cuerpo: cursiva',
  'portal_email_theme.body_color': 'Cuerpo: color',
  delivery_method: 'Método de devolución',
  shipping_method: 'Método de envío',
  location: 'Ubicación',
  packaging: 'Embalaje',
  exception: 'Excepción',
  refund_method: 'Método de reembolso',
  return_reason: 'Motivo de devolución',
  email_template: 'Plantilla de correo',
  integration: 'Integración',
  user: 'Usuario',
  group: 'Grupo',
  policy_rule: 'Regla condicional',
  'widget.background_color': 'Color del fondo',
  'widget.text_color': 'Color del texto',
  'widget.link_color': 'Color del link',
  'widget.show_custom_text': 'Usar texto personalizado',
  'shipping_widget.background_color': 'Color del fondo',
  'shipping_widget.text_color': 'Color del texto',
  'shipping_widget.actions_color': 'Color de las acciones',
  'shipping_widget.free_shipping_background_color': 'Color de fondo: "Consigue envío gratis"',
  'shipping_widget.free_shipping_text_color': 'Color de texto: "Consigue envío gratis"',
  'shipping_widget.sorting': 'Ordenación métodos de envío',
  'recommendation_widget.background_color': 'Color del fondo',
  'recommendation_widget.text_color': 'Color del texto',
  'recommendation_widget.product_taxonomy_display': 'Mostrar para',
  'recommendation_widget.product_taxonomy_ids': 'Categorías de producto seleccionadas',
  'top_banner_widget.background_color': 'Color del fondo',
  'top_banner_widget.text_color': 'Color del texto',
  'top_banner_widget.link_color': 'Color del link',
  'bracketing_widget.background_color': 'Color del fondo',
  'bracketing_widget.text_color': 'Color del texto',
  'bracketing_widget.link_color': 'Color del link',
  'bracketing_widget.size_guide_url': 'Guía de tallas',
  'tryon_widget.background_color': 'Color del fondo',
  'tryon_widget.text_color': 'Color del texto',
  'tryon_widget.button_color': 'Color del botón',
  'tryon_widget.button_hover_color': 'Color del botón hover',
  'tryon_widget.product_taxonomy_type': 'Mostrar por',
  'tryon_widget.product_taxonomy_display': 'Mostrar para',
  'tryon_widget.product_taxonomy_ids': 'Categorías, colecciones o tags',
  'return_protection.widget_background_color': 'Color de fondo',
  'return_protection.widget_text_color': 'Color de texto',
  'return_protection.widget_link_color': 'Color de enlace',
  'return_protection.popup_header_image': 'Imagen de cabecera',
  'return_protection.popup_overlay_color': 'Color de superposición',
  'return_protection.popup_header_text_color': 'Color del texto de cabecera',
  'return_protection.popup_body_text_color': 'Color del texto del cuerpo',
  'return_protection.decline_action_style': 'Continuar sin Return Protection',
  'return_protection_product.product_image': 'Imagen del producto',
  'return_protection_product.product_title': 'Texto de la etiqueta',
}
